import { sendToSlack } from '../../data/slack/sendToSlack';
import { Label } from '../atoms/Label';
import { SlackMessageModal } from './SlackMessageModal';

const DataErrorModalContent = ({
  content,
  showSlackForm,
  metadata,
  onClose,
}: {
  content: string[];
  showSlackForm?: boolean;
  metadata?: Record<string, any>;
  onClose?: () => void;
}) => {
  return (
    <>
      {content.map((line, index) => (
        <Label key={index} titleType="body">
          {line}
        </Label>
      ))}

      {showSlackForm && (
        <SlackMessageModal
          isOpen={true}
          onClose={() => {
            onClose && onClose();
          }}
          onSubmit={async (message, meta) => {
            return await sendToSlack(message, {
              ...meta,
            });
          }}
          metadata={{ errorDetails: content.join('\n'), ...metadata }}
        />
      )}
    </>
  );
};

export default DataErrorModalContent;
